import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig.js";
import { ToastProvider } from "./toast/ToastProvider.jsx";
import BookingPlatform from "./components/BookingPlatform.jsx";
import BookingLanding from "./components/BookingLanding.jsx";
import ManageBooking from "./components/ManageBooking.jsx";
import LoginPage from "./components/LoginPage.jsx";
import ConfigPage from "./components/ConfigPage.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <ToastProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin */}
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/config"
            element={
              <ProtectedRoute>
                <ConfigPage />
              </ProtectedRoute>
            }
          />

          {/* Valid booking link: /mek/{linkId} — namespaced so new top-level
              paths (e.g. /health, /sitemap.xml) don't collide with link IDs */}
          <Route path="/mek/:linkId" element={<BookingPlatform />} />

          {/* "Manage your booking" link from the confirmation email */}
          <Route path="/manage/:token" element={<ManageBooking />} />
          <Route path="/m/:token" element={<ManageBooking />} />

          {/* Root + anything else falls back to the landing page */}
          <Route path="/" element={<BookingLanding />} />
          <Route path="*" element={<BookingLanding />} />
        </Routes>
      </BrowserRouter>
      </ToastProvider>
    </MsalProvider>
  );
}
